<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="student.urlProfilePhoto"
    >
      <template v-slot:header>
        {{$t('notifications.lessonBooked')}}
      </template>
      <template v-slot:actions>
        <div>
          {{$t('notifications.booked')}}
          <router-link :to="`/students/${student.slug}`" class="font-medium">
          {{ student.name }}
          </router-link>
        </div>
        <button class="flex rounded-sm p-2 text-orange-academy-300 mt-2 uppercase
          border opacity-60 hover:opacity-100 border-orange-academy-300 items-center"
          @click="contact(user, student.user)"
        >
            <message-icon class="w-5"/>
            <span class="pl-3">
            {{$t('notifications.sendMessage')}} {{ student.name }}
            </span>
        </button>
      </template>
    </notification-template>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NotificationTemplate from './NotificationTemplate.vue';
import StreamFunctionsMixin from '../../mixins/StreamFunctionsMixin';
import MessageIcon from '../graphics/MessageIcon.vue';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      student: { ...this.notification.data.student },
      lesson: { ...this.notification.data.lesson },
    };
  },
  components: {
    NotificationTemplate,
    MessageIcon,
  },
  mixins: [StreamFunctionsMixin],
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    ...mapActions({
      toggleNotifications: 'toggleNotifications',
    }),
    goToDashboard() {
      if (!this.large) {
        this.toggleNotifications();
        this.$router.push(`/teacher-dashboard#${this.notification.id}`).catch(() => {});
      }
    },
  },
};
</script>
